document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.discover-range').forEach(function (section) {
    var filters = section.querySelectorAll('.discover-range__filter');
    var cards = section.querySelectorAll('.discover-range__card');
    var seeMoreLinks = section.querySelectorAll('.discover-range__see-more');
    var track = section.querySelector('.discover-range__track');

    function applyFilter(target) {
      cards.forEach(function (card) {
        var group = card.getAttribute('data-collection-group');
        var isExtra = card.classList.contains('is-extra');
        var belongsToTarget = group === target;

        card.hidden = !(belongsToTarget && !isExtra);
        card.classList.remove('is-hidden-initial');
      });

      seeMoreLinks.forEach(function (link) {
        var group = link.getAttribute('data-collection-group');
        link.hidden = group !== target;
      });

      if (track) track.scrollTo({ top: 0, behavior: 'smooth' });
    }

    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        filters.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');

        applyFilter(btn.getAttribute('data-collection'));
      });
    });

    var activeBtn = section.querySelector('.discover-range__filter.is-active');
    if (activeBtn) {
      applyFilter(activeBtn.getAttribute('data-collection'));
    }
  });
});